import { createContext, useContext, useState, type Dispatch, type PropsWithChildren, type SetStateAction } from "react"

type ContextValue = [string[], Dispatch<SetStateAction<string[]>>]

const FiltersAccordionStateContext = createContext<ContextValue | null>(null)

export function useFiltersAccordionState() {
  const context = useContext(FiltersAccordionStateContext)

  if (!context) {
    throw new Error("useFiltersAccordionState must be used within a FiltersAccordionStateProvider")
  }

  return context
}

export function FiltersAccordionStateProvider({ children }: PropsWithChildren) {
  const state = useState<string[]>([])
  return <FiltersAccordionStateContext.Provider value={state}>{children}</FiltersAccordionStateContext.Provider>
}
